const header = document.querySelector(".header");

if (header) {
  const links = document.querySelectorAll("[data-link]");
  const sections = document.querySelectorAll("section");

  const options = {
    root: null,
    rootMargin: `0px 0px -${
      document.documentElement.clientHeight - header.clientHeight - 200
    }px 0px`,
    threshold: 0,
  };

  const observeSection = (entries) => {
    let currentEntry = null;
    if (entries.length > 1) {
      currentEntry = entries.find((entry) => entry.isIntersecting);
    } else {
      currentEntry = entries[0];
    }

    let isIntersecting = currentEntry?.isIntersecting;

    if (isIntersecting) {
      if (currentEntry) {
        const section = currentEntry.target;

        if (section) {
          const dataSection = section.dataset.section;

          if (dataSection) {
            links.forEach((link) => {
              const dataLink = link.dataset.link;
              link.classList.remove("active");

              if (dataLink === dataSection) {
                link.classList.add("active");
              }
            });
          } else {
            links.forEach((link) => link.classList.remove("active"));
          }
        }
      }
    }
  };

  links.forEach((link) => {
    link.addEventListener("click", () => {
      const dataLink = link.dataset.link;

      sections.forEach((section) => {
        const dataSection = section.dataset.section;

        if (dataSection) {
          link.classList.remove("active");

          if (dataLink === dataSection) {
            link.classList.add("active");
            section.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  });

  const observer = new IntersectionObserver(observeSection, options);
  sections.forEach((section) => observer.observe(section));
}
